export default __webpack_public_path__ + "static/media/higher_icon_chat_reversed.155cc800.svg";